<template>
    <pg-page title="Private Gym Testimonial - Aad"
             header="Testimonial van Aad - Deventer"
             id="testimonial-002"
    >

        <p>
            <strong>Oké Aad, laten we gelijk beginnen want je gaat zometeen sporten natuurlijk. De eerste vraag: Je bent nu klant van Private Gym, maar was er iets waardoor je tóch even twijfelde voordat je je inschreef?</strong>
        </p>

        <p>
            <em>
                Nee dat was er eigenlijk niet.
            </em>
        </p>

        <p>
            <strong>
                Ah, dat is fijn. En als je nu terugkijkt... je hebt je aangemeld in het begin... Wat was voor jou de reden dat je dacht van; dít is waarom ik de rondleiding wil.
            </strong>
        </p>

        <p>
            <em>
                Private Gym stond me aan in de zin van; ik kan een tijd reserveren en ik heb een eiland voor mezelf. En waar ik niet hoef te wachten en dus mijn eigen oefeningen kan doen. Dat is met de rondleiding ook heel duidelijk geworden eigenlijk.
            </em>
        </p>

        <rondleiding-button button_text="Ontdekken of Private Gym iets voor jou is? Plan direct een rondleiding"></rondleiding-button>

        <p>
            <strong>
                Als je één favoriet ding mag noemen, je hebt nu al een paar keer getraind, wat springt er dan echt voor jou uit als het om het trainen gaat bij Private Gym?
            </strong>
        </p>

        <p>
            <em>
                Ehm, op het moment dat het nog erg rustig is haha
            </em>
        </p>

        <p>
            <strong>
                Dat is voor mij een minder favoriet ding ;-)  Denk je dat het anders wordt? Op het drukste moment is er nu drie man aan het trainen. Stel dat er zeven man aan het trainen is, zou dat veel uitmaken voor je?
            </strong>
        </p>

        <p>
            <em>
                Nee, ik denk het niet. Maar in de beginfase waar ik nu ook in zit, ziet in ieder geval niet iedereen hoe ik bezig ben.
            </em>
        </p>

        <p>
            <strong>
                Dan is het inderdaad handig dat we binnenkort met zijn tweeën aan de slag gaan / dat je personal training krijg, zodat je zelfverzekerd aan die pully staat te trekken.
                <br/>
                <br/>
                Gaan we verder. Je hebt het net al genoemd, maar ik wil het nog even specifiek uitlichten: Kun je nog drie andere voordelen noemen?
            </strong>
        </p>

        <p>
            <em>
                De tijden dat ik terecht kan, de vrijheid daarin. De reservering kunnen doen. Het eigen eiland.
            </em>
        </p>

        <p>
            <strong>
                Standaard vraag, maar het zegt altijd wel veel: Zou je Private Gym aanraden aan iemand anders en zo ja, waarom? Al heb je dat eigenlijk al gedaan natuurlijk, met je zoon.
            </strong>
        </p>

        <p>
            <em>
                Ja mijn zoon inderdaad, en mijn overbuurman. Mijn andere zoon wil ook nog een keer.
                Dus ja, ik zou het wel aanraden.<br/>
                <br/>
                Ik moet nog wel de handigheid en snelheid erin krijgen, met wat ik op welk apparaat kan doen.
            </em>
        </p>

        <p>
            <strong>
                Dat is ook fijne feedback voor mij om ervoor te zorgen dat de Aad in de toekomst, want jij deelt het nu direct en dat is superfijn, dat die daar misschien iets minder vrij in is om dat te delen daar niet tegenaan loopt en dat het direct goed gaat. Zo maken we samen de best mogelijke ervaring.
                <br/>
                <br/>
                Is er nog iets anders waar ik nog niet naar gevraagd heb maar wat je wel zou willen toevoegen?
            </strong>
        </p>

        <p><em>
            Ja, waar blijft die tas?! :D
        </em></p>

        <p><strong>
            Ja! Die zijn er inmiddels weer! Goeie vraag, maar dat gaan we regelen. <em>[Red: Aad en zijn zoons hebben inmiddels een Private Gym sport-tas 😄]</em>
        </strong></p>

        <p><em>Maar eigenlijk hebben we vanmiddag al een beetje besproken wat de behoefte is van ons uit, en ik denk ook vanuit meerdere mensen, als je niet getraind naar PG gaat. Het aanbod van een Personal Trainer erbij zou mooi zijn.
            <br/>
            <br/>
            [Red: inmiddels is PT in de checkout direct aan te vragen en voor iedereen beschikbaar]
        </em></p>

        <p><strong>
            Ja, ik zie dat als een soort van ondersteuning want het is belangrijk dat je met plezier en zelfvertrouwen staat te trainen. En dat je er op die manier ook elke keer met plezier naartoe gaat. In tegenstelling tot wat je vertelde over [Andere Sportschool], dat je er eigenlijk er tegenop ziet en dat je daardoor niet gaat. Ik vind het een heel mooi compliment dat je zegt: Ik ga nu wel sporten!
        </strong></p>

        <rondleiding-button button_text="Ontdekken of Private Gym iets voor jou is? Plan direct een rondleiding"></rondleiding-button>

    </pg-page>
</template>

<script>

import PgPage from "../../Components/PgPage";
import ContactModal from "../../Components/Contact/ContactModal";
import RondleidingButton from "../../Components/Index/RondleidingButton";
export default {
    components: {RondleidingButton, ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            showFormModal: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style>

</style>
